import { Save, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface SaveButtonProps {
  isPending?: boolean;
  isEdit?: boolean;
  children?: React.ReactNode;
  type?: 'submit' | 'button';
  disabled?: boolean;
  onClick?: () => void;
  size?: 'default' | 'sm';
  form?: string;
  className?: string;
}

export function SaveButton({
  isPending = false,
  isEdit = false,
  children,
  type = 'submit',
  disabled,
  onClick,
  size,
  form,
  className,
}: SaveButtonProps): React.ReactElement {
  const text = children ?? (isEdit ? 'Save Changes' : 'Save');

  return (
    <Button
      type={type}
      size={size}
      form={form}
      className={className}
      disabled={isPending || disabled}
      onClick={onClick}
    >
      {isPending ? (
        <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" />
      ) : (
        <Save className="mr-1.5 h-3.5 w-3.5" />
      )}
      {text}
    </Button>
  );
}
